import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import i18next from "i18next"; // Importe a instância do i18next
import getAPIbaseURL from "../../utils/helpers";

const API_URL = `${getAPIbaseURL()}/teams/`;
const authHeaders = () => ({ Authorization: `Bearer ${localStorage.getItem("token")}` });

export const fetchTeams = createAsyncThunk(
  "teams/fetchTeams",
  async (_, thunkAPI) => {
    try {
      const response = await axios.get(`${API_URL}/`, { headers: authHeaders() });
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || i18next.t("teams.errors.fetch"));
    }
  }
);

export const fetchTeamMembers = createAsyncThunk(
  "teams/fetchTeamMembers",
  async (teamId, thunkAPI) => {
    try {
      const response = await axios.get(`${API_URL}${teamId}/members`, { headers: authHeaders() });
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || i18next.t("teams.errors.fetchMembers"));
    }
  }
);

export const createTeam = createAsyncThunk(
  "teams/createTeam",
  async ({ name, description }, thunkAPI) => {
    try {
      const response = await axios.post(`${API_URL}/`, { name, description }, { headers: authHeaders() });
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || i18next.t("teams.errors.create"));
    }
  }
);

export const updateTeam = createAsyncThunk(
  "teams/updateTeam",
  async ({ id, name, description }, thunkAPI) => {
    try {
      const response = await axios.put(`${API_URL}${id}`, { name, description }, { headers: authHeaders() });
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || i18next.t("teams.errors.update"));
    }
  }
);

export const deleteTeam = createAsyncThunk(
  "teams/deleteTeam",
  async (teamId, thunkAPI) => {
    try {
      await axios.delete(`${API_URL}${teamId}`, { headers: authHeaders() });
      return teamId;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || i18next.t("teams.errors.delete"));
    }
  }
);

export const addTeamMember = createAsyncThunk(
  "teams/addTeamMember",
  async ({ teamId, userId }, thunkAPI) => {
    try {
      const response = await axios.post(
        `${API_URL}${teamId}/members`,
        { user_id: userId },
        { headers: authHeaders() }
      );
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || i18next.t("teams.errors.addMember"));
    }
  }
);

export const removeTeamMember = createAsyncThunk(
  "teams/removeTeamMember",
  async ({ teamId, userId }, thunkAPI) => {
    try {
      await axios.delete(`${API_URL}${teamId}/members/${userId}`, { headers: authHeaders() });
      return { teamId, userId };
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || i18next.t("teams.errors.removeMember"));
    }
  }
);


const isTeamsAction = (action) => action.type.startsWith("teams/");
const isPending = (action) => action.type.endsWith("/pending");
const isFulfilled = (action) => action.type.endsWith("/fulfilled");
const isRejected = (action) => action.type.endsWith("/rejected");

const teamsSlice = createSlice({
  name: "teams",
  initialState: {
    items: [],
    isLoading: false,
    error: null,
  },
  reducers: {},
  
  extraReducers: (builder) => {
    builder
      .addCase(fetchTeams.fulfilled, (state, action) => {
        state.items = action.payload;
      })
      .addCase(createTeam.fulfilled, (state, action) => {
        state.items.push(action.payload);
      })
      .addCase(updateTeam.fulfilled, (state, action) => {
        const index = state.items.findIndex((t) => t.id === action.payload.id);
        if (index !== -1) {
          state.items[index] = { ...state.items[index], ...action.payload };
        }
      })
      .addCase(deleteTeam.fulfilled, (state, action) => {
        state.items = state.items.filter((t) => t.id !== action.payload);
      })
      .addMatcher(
        (action) => isTeamsAction(action) && isPending(action),
        (state) => { state.isLoading = true; state.error = null; }
      )
      .addMatcher(
        (action) => isTeamsAction(action) && isFulfilled(action),
        (state) => { state.isLoading = false; }
      )
      .addMatcher(
        (action) => isTeamsAction(action) && isRejected(action),
        (state, action) => { state.isLoading = false; state.error = action.payload; }
      );
  },
});

export default teamsSlice.reducer;